import React from 'react'
import { ListGroup } from 'react-bootstrap'
import { VoucherType } from '../../types'
import FilePreviewButton from '../Common/FilePreviewButton'
import ApprovalStages from '../Common/ApprovalStages'
import { formatPaymentDate } from '../../utils/utils'

type VoucherExpandedRowProps = {
  voucher: VoucherType
  showPaymentInfo?: boolean
}

const VoucherExpandedRow: React.FC<VoucherExpandedRowProps> = ({
  voucher,
  showPaymentInfo = false,
}) => {
  return (
    <div className="p-3 bg-light">
      <ApprovalStages voucher={voucher} />
      <br />

      <h4>Description</h4>
      <p style={{ whiteSpace: 'pre-wrap' }}>{voucher.description}</p>

      <h4>Cost Categories</h4>
      <ListGroup variant="flush">
        {voucher.voucher_cost_category.map((cat) => (
          <ListGroup.Item key={cat.id}>
            <strong>
              {cat.cost_category.parent.name} | {cat.cost_category.name} ({cat.cost_category.code})
            </strong>
            : {cat.cost_share} {voucher.currency}
            {cat.receipts && cat.receipts.length > 0 && (
              <ul>
                {cat.receipts.map((r) => (
                  <li key={r.id}>
                    <FilePreviewButton fileId={r.id} fileName={r.path}>
                      {r.path}
                    </FilePreviewButton>
                  </li>
                ))}
              </ul>
            )}
          </ListGroup.Item>
        ))}
      </ListGroup>
      <br />
      {showPaymentInfo && (
        <>
          <h4>Payment Information</h4>
          <p>
            <strong>Pay To:</strong> {voucher.pay_to || '-'}
            <br />
            <strong>Payment Date:</strong>{' '}
            {formatPaymentDate(voucher.paid_by_amin)}
          </p>
        </>
      )}
    </div>
  )
}

export default VoucherExpandedRow
